<div class="text">
  <div class="name">
    @if (url()) {
      <a [href]="url()" target="_blank" style="color: #1e1b12;">{{ name() }}</a>
    } @else {
      {{ name() }}
    }
  </div>
</div>